import SdsInputText from "@salesforce-ux/sds-components/src/input-text/input-text";
import css from "./input-text.css";

export default class FooInputText extends SdsInputText {
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.innerHTML += `<style>${css}</style>`;
  }
}
